//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.wintermar.inspection.graphql.DeleteInspectionReportMutation
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object DeleteInspectionReportMutation_ResponseAdapter {
  public object Data : Adapter<DeleteInspectionReportMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("deleteInspectionReport")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): DeleteInspectionReportMutation.Data {
      var _deleteInspectionReport: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _deleteInspectionReport = AnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return DeleteInspectionReportMutation.Data(
        deleteInspectionReport = _deleteInspectionReport ?: missingField(reader, "deleteInspectionReport")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: DeleteInspectionReportMutation.Data,
    ) {
      writer.name("deleteInspectionReport")
      AnyAdapter.toJson(writer, customScalarAdapters, value.deleteInspectionReport)
    }
  }
}
